export default {
  header: {
    menus: {
      about: 'Acerca',
      members: 'Miembros',
      events: {
        title: 'Eventos',
        dropdown: {
          colloquia: {
            title: 'Coloquios',
            summary: 'Encuentros internacionales temáticos',
          },
          seminary: {
            title: 'Seminarios',
            summary: 'Seminarios regulares ya presentados por los miembros de la red',
          },
        }
      },
      publications: {
        title: 'Publicaciones',
        dropdown: {
          articles: {
            title: 'Artículos',
            summary: 'Artículos sobre mitocrítica publicados por los miembros de la Red Pachamama',
          },
          books: {
            title: 'Libros',
            summary: 'Libros sobre mitocrítica publicados por los miembros de la Red Pachamama',
          },
          magazines: {
            title: 'Revistas',
            summary: 'Revistas vinculadas a la Red Pachamama',
          },
        },
      },
      talkToUs: 'Contáctenos'
    },
    beOneOfUs: 'Únete a nosotros',
  },
  dropdown: {
    qrCodeDesc: 'Escaneie el código QR o envíe un mensaje al correo electrónico a continuación para ponerse en contacto.',
  },
  footer: {
    title: 'Aún tienes preguntas? Contáctanos',
    menus: {
      about: 'Acerca',
      members: 'Miembros',
      events: {
        title: 'Eventos',
        colloquia: 'Coloquios',
        seminary: 'Seminarios',
      },
      publications: {
        title: 'Publicaciones',
        articles: 'Artículos',
        books: 'Libros',
        magazines: 'Revistas ',
      },
      talkToUs: 'Contáctenos'
    },
    beOneOfUs: 'ÚNETE A NOSOTROS',
    copy: '2024 Pachamama. todos os direitos reservados',
  },
};